import React from 'react';
import PropTypes from 'prop-types';
import {fetchSender} from "../../services";
import Fetch from "../../Elements/Fetch";
import SenderMigrationForm from "./SenderMigrationForm";

const SenderMigrationRoute = ({match, history, onSubmit}) => (
    <Fetch fetchFunction={fetchSender} fetchFunctionParams={match.params.id}>
        {sender => {
            const handleSubmit = onSubmit || (() => history.push('/senders/' + sender.id));
            return (
                <div style={{maxWidth: 800}}>
                    <SenderMigrationForm
                        sender={sender}
                        onSubmit={handleSubmit}
                    />
                </div>
            );
        }}
    </Fetch>
);

SenderMigrationRoute.propTypes = {
    onSubmit: PropTypes.func,
};

export default SenderMigrationRoute;